import React, { Component } from 'react';
import { Modal, Button } from "react-bootstrap"
import { withTranslation } from 'react-i18next';

class CategoryDeleteConfirm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            transPage: "modals.category_delete."
        }

        this.deleteSelectedCategory = this.deleteSelectedCategory.bind(this)
        this.onOpenModal = this.onOpenModal.bind(this)
        // this.onHideModal = this.onHideModal.bind(this)
    }

    deleteSelectedCategory() {
        // dari props method nya
        this.props.deleteSelectedCategory() 
    }

    onOpenModal() {
        //console.log("modal open")
    }

    
    render() {
        const {t} = this.props;
        const listCategories = this.props.selectedCategory.map(item => {
            return (<li key={item.id}>{ item.category }</li>)
        })

        return (
            <Modal show={this.props.show} onHide={() => this.props.onHide()} onShow={() => this.onOpenModal()}>
               
                <Modal.Header closeButton className="bg-danger">
                    <Modal.Title>{t(this.state.transPage + "title")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>{t(this.state.transPage + "confirmation_text")}</p>
                    <ul>
                        {listCategories}
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.props.onHide()}>
                        {t('cancel')}
                    </Button>
                    <Button variant="danger" onClick={() => this.deleteSelectedCategory()}>
                        <i className="fa fa-trash">&nbsp;</i>
                        {t(this.state.transPage + "delete_category")}
                    </Button>   
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withTranslation()(CategoryDeleteConfirm);